import { useTranslation } from "react-i18next";

import { GoogleIcon } from "@/components/brand";
import { useDocumentTitle } from "@/components/page";
import { GOOGLE_LOGIN_URL } from "@/routes/paths";
import { Button } from "@punto-firma/ui/components/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@punto-firma/ui/components/card";

import { CenteredScreen } from "./centered-screen";

/**
 * Un solo botón. Es una navegación de página entera: el `api` hace el OIDC con
 * Google y vuelve con la cookie de sesión; si no puede entrar, a `/no-access`.
 */
export const LoginPage = () => {
  const { t } = useTranslation("auth");
  useDocumentTitle(t("login.title"));

  return (
    <CenteredScreen>
      <Card>
        {/* El nombre ya lo pone la marca de encima. */}
        <CardHeader className="text-center">
          <CardDescription className="text-base text-foreground">
            {t("login.tagline")}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button asChild size="lg" variant="outline" className="w-full">
            <a href={GOOGLE_LOGIN_URL}>
              <GoogleIcon className="mr-2 size-4" />
              {t("login.google")}
            </a>
          </Button>
        </CardContent>
      </Card>
    </CenteredScreen>
  );
};
